'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/6/30.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageChangeComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ImageChangeComponent, _Component);

  function ImageChangeComponent() {
    (0, _classCallCheck3.default)(this, ImageChangeComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ImageChangeComponent).call(this));

    _this.state = {
      centerImgSrc: ''
    };
    return _this;
  }

  (0, _createClass3.default)(ImageChangeComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'onImageItemClick',
    value: function onImageItemClick(imgUrl) {
      this.setState({
        centerImgSrc: imgUrl
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ImageChangeComponent.scss');
      var _props = this.props;
      var data = _props.data;
      var _style = _props._style;

      return _react2.default.createElement(
        'div',
        { className: styles.img_banner, style: { _style: _style } },
        _react2.default.createElement(
          'ul',
          { className: styles.banner_big },
          _react2.default.createElement(
            'li',
            { className: styles.z_d_2 },
            _react2.default.createElement('img', {
              src: this.state.centerImgSrc || data[0].img, alt: '' })
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: styles.banner_small },
          data instanceof Array ? data.map(function (item, index) {
            var liStyle = {};
            if (item.img === _this2.state.centerImgSrc || !_this2.state.centerImgSrc && item.img === data[0].img) {
              liStyle = { width: '130%' };
            }
            return _react2.default.createElement(
              'li',
              { key: 'imageChange' + index, onClick: function onClick() {
                  return _this2.onImageItemClick(item.img);
                }, style: liStyle },
              _react2.default.createElement('img', {
                src: item.img, alt: '' })
            );
          }) : ''
        )
      );
    }
  }]);
  return ImageChangeComponent;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array.isRequired,
  _style: _react.PropTypes.object
}, _temp);
exports.default = ImageChangeComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ImageChangeComponent/ImageChangeComponent.js
 ** module id = 1357
 ** module chunks = 0
 **/